document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.article-content') || document.querySelector('.post_content')
  if (!container) return

  const heads = container.querySelectorAll('h2')
  let tableOfContent = document.createElement('div');
  tableOfContent.id = 'table-of-content';
  tableOfContent.classList.add('mb-10', 'p-8', 'inline-block', 'bg-gray-100')

  tableOfContent.innerHTML += '<p class="font-bold text-xl">▼ 目次</p>'

  if (heads && heads.length) {
    let contents = ''
    heads.forEach((head, i) => {
      contents += `<li><a class="contents2" href="#head${i}">${head.textContent}</a></li>`
      head.innerHTML += `<a id="head${i}"></a>`
    })
    tableOfContent.innerHTML += `<ol>${contents}</ol>`

    heads[0].before(tableOfContent)
  }
})
